export default __webpack_public_path__ + "static/media/c11e9c7b30137e43eb359b821d683e0a.svg";